module.exports = __webpack_public_path__ + "static/media/stb.976017e4.png";